<app-header [clicked]="clickedOutside" (changeMegaMenuCondition)="changeMenuCondition($event)"></app-header>

<section
    (click)="closeMegaMenuCondition()"
    class="tw-flex tw-justify-center tw-px-[15px] md:tw-px-[70px] tw-py-[40px] tw-w-full"
>
    <div class="tw-w-full tw-max-w-[1440px]">
        <header>
            <nav
                class="tw-px-4 md:tw-px-6 tw-gap-[10vw] tw-flex tw-items-center tw-justify-between tw-font-semibold"
            >
                <div class="tw-text-white">
                    <div class="tw-text-sky-900 tw-text-[22px] md:tw-text-4xl">
                        {{ "COMMON.GET_THE_LATEST" | translate }}
                    </div>
                </div>
            </nav>
        </header>

        <div
            class="lg:tw-hidden tw-ml-[2px] tw-mr-[5px] tw-px-[5vw] md:tw-pl-0 tw-flex tw-py-5 md:tw-py-10 tw-gap-[2rem] md:tw-gap-0 tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-bg-gradient-to-l tw-from-[#162EAF] tw-to-[#030826] tw-rounded-[20px] tw-mt-8"
            *ngFor="let item of newsDetailsArr; let i = index"
        >
            <div class="sm:tw-ml-[2vw]">
                <img
                    class="tw-rounded-2xl tw-w-80 tw-h-60"
                    [src]="item.image" alt="News details img"
                />
            </div>
            <div class="tw-px-[3vw] tw-flex-1">
                <div class="tw-flex tw-items-center tw-flex-nowrap tw-gap-3">
                    <span
                        class="tw-text-gray-400 tw-text-base tw-font-medium tw-leading-normal"
                        >{{ item?.category }}
                    </span>
                </div>
                <div>
                    <div
                        class="tw-text-white tw-mt-5 tw-text-2xl tw-leading-relaxed lg:tw-text-[40px] tw-font-semibold"
                    >
                        {{ item?.headline }}
                    </div>
                </div>

                <div
                    class="tw-text-gray-400 tw-mt-5 tw-text-base tw-leading-normal"
                >
                    {{ item?.timestamp }}
                </div>
            </div>
        </div>

        <div
            class="tw-hidden lg:tw-flex tw-w-full tw-justify-center md:tw-py-[40px] xl:tw-py-[70px] tw-ml-[2px] tw-mr-[5px] tw-px-[5vw] md:tw-pl-0 tw-gap-[2rem] md:tw-gap-0 tw-flex-col md:tw-flex-row tw-items-start md:tw-items-center tw-bg-gradient-to-r tw-from-blue-800 tw-to-slate-900 tw-rounded-[20px] tw-mt-8"
        >
            <ng-container *ngFor="let item of newsDetailsArr; let i = index">
                <div
                    class="tw-px-[70px] tw-max-w-[750px] tw-w-full tw-flex-1"
                    [routerLink]="'/blogs/' + item.id"
                >
                    <div
                        class="tw-flex tw-items-center tw-flex-nowrap tw-gap-3"
                    >
                        <span
                            class="tw-text-gray-400 tw-text-base tw-font-medium tw-leading-normal"
                            >{{ item?.category }}
                        </span>
                    </div>
                    <div>
                        <div
                            class="tw-text-white tw-mt-7 tw-leading-tight tw-text-2xl lg:tw-text-[40px] tw-font-semibold"
                        >
                            {{ item?.headline }}
                        </div>
                    </div>
                    <div class="tw-text-gray-400 tw-mt-7">
                        {{ item?.timestamp }}
                    </div>
                </div>
                <img
                    class="tw-max-w-[300px] xl:tw-max-w-[670px] tw-min-w-[310px] tw-max-h-[470px] tw-rounded-2xl"
                    [src]="item?.image"
                    alt="blog-image"
                />
            </ng-container>
        </div>

        <ng-container *ngFor="let item of newsDetailsArr; let i = index">
            <div class="lg:tw-hidden tw-px-5 tw-mt-6 tw-text-gray-400">
                {{ item?.newsDetails }}
            </div>
        </ng-container>

        <div
            class="tw-flex tw-mt-[70px] tw-w-full tw-gap-[60px] tw-justify-between"
        >
            <ng-container *ngFor="let item of newsDetailsArr; let i = index">
                <div
                    class="tw-hidden tw-basis-[60%] lg:tw-block tw-px-5 tw-mt-6 tw-text-gray-400"
                >
                    {{ item?.newsDetails }}
                </div>
            </ng-container>
            <div
                class="tw-max-w-[630px] tw-w-full [&>*]:tw-border-b [&>*]:tw-border-b-[#EBEBEC] tw-justify-center"
            >
                <div
                    class="tw-text-[24px] tw-text-primary-blue-dark tw-pb-[10px] tw-border-b-[1px] tw-border-b-gray-400"
                >
                    Highlights
                </div>
                <ng-container
                    *ngFor="let item of showNewsHighlights; let i = index"
                >
                    <div
                        class="tw-py-[30px] tw-flex tw-max-w-[630px] tw-w-full tw-gap-[1rem] lg:tw-gap-[2vw] tw-flex-1"
                    >
                        <div class="tw-flex-shrink-0">
                            <img
                                class="tw-rounded-lg tw-w-[127px] tw-h-[90px] tw-cursor-pointer"
                                [routerLink]="'/blogs/' + item.id"
                                [src]="item.image"
                                alt="blog-image"
                            />
                        </div>
                        <div class="tw-text-sm lg:tw-text-base tw-max-h-[90px]">
                            <div
                                [routerLink]="'/blogs/' + item.id"
                                class="tw-hidden lg:tw-block tw-text-sky-900 tw-max-w-[340px] tw-w-full tw-text-lg xl:tw-text-2xl tw-font-semibold tw-cursor-pointer"
                            >
                                {{
                                    item.headline?.length > 43
                                        ? (item.headline | slice: 0 : 43) +
                                          "..."
                                        : item.headline
                                }}
                            </div>

                            <div
                                [routerLink]="'/blogs/' + item.id"
                                class="tw-block lg:tw-hidden tw-cursor-pointer tw-text-sky-900 tw-max-w-[340px] tw-w-full tw-text-lg xl:tw-text-2xl tw-font-semibold"
                            >
                                {{
                                    item.headline?.length > 37
                                        ? (item.headline | slice: 0 : 37) +
                                          "..."
                                        : item.headline
                                }}
                            </div>

                            <div
                                class="[&>*]:tw-whitespace-nowrap tw-text-sm tw-mt-2 tw-flex tw-flex-nowrap tw-gap-[5px] md:tw-gap-[10px] md:tw-mb-[1rem]"
                            >
                                <span class="tw-text-gray-400 tw-font-medium"
                                    >{{ item.category }} </span
                                ><span
                                    class="tw-text-neutral-400 tw-font-medium"
                                    >|</span
                                ><span
                                    class="tw-text-neutral-400 tw-font-medium"
                                    >{{ item.timestamp }}</span
                                >
                            </div>
                        </div>
                        <div
                            class="md:tw-flex tw-hidden tw-flex-grow tw-text-end tw-justify-end tw-self-start tw-mt-3"
                        >
                            <a
                                [routerLink]="'/blogs/' + item.id"
                                class="news-details"
                            >
                                <img
                                    class="tw-w-7 tw-h-7"
                                    src="../../../../assets/images/announcement-sub-arrow.svg"
                                    alt="arrow"
                                />
                            </a>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</section>

<app-footer (click)="closeMegaMenuCondition()"></app-footer>
